var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4868 5.93306L3.43755 13.9823C3.32664 14.0933 3.25701 14.2388 3.24023 14.3948L2.75417 18.768C2.74354 18.8641 2.75329 18.9613 2.78278 19.0534C2.81228 19.1454 2.86085 19.2302 2.92534 19.3023C2.98983 19.3743 3.06878 19.4319 3.15704 19.4713C3.2453 19.5108 3.34088 19.5311 3.43755 19.5311C3.46281 19.5311 3.48806 19.5297 3.51317 19.527L7.88911 19.0409C8.04509 19.0242 8.19065 18.9545 8.30161 18.8436L16.3481 10.7951L11.4868 5.93306ZM19.5003 4.72581L17.5554 2.78087C17.1686 2.39421 16.6441 2.177 16.0972 2.177C15.5503 2.177 15.0258 2.39421 14.639 2.78087L12.4589 4.96094L17.3202 9.82294L19.501 7.64219C19.8876 7.25532 20.1046 6.73076 20.1045 6.18386C20.1044 5.63696 19.887 5.1125 19.5003 4.72581Z",
    fill: "#EF7F1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.a39a8ae6382e8bc7958660167798b959.svg";
export { ForwardRef as ReactComponent };